import { useEffect, useRef, useState } from "react";
import { landingContent } from "../../data/landingContent";

// TODO: Replace with real values from your analytics/App Store
const METRICS = [
  {
    end: 50000,
    format: (n: number) => `${Math.round(n / 1000)}K+`,
    key: "publicSearches",
    accent: false,
  },
  {
    end: 150,
    format: (n: number) => `${n}+`,
    key: "countries",
    accent: false,
  },
  {
    end: 0,
    format: () => "0",
    key: "passwordsRequired",
    accent: true, // guaranteed true — always 0
  },
] as const;

function CountUp({
  end,
  format,
  started,
}: {
  end: number;
  format: (n: number) => string;
  started: boolean;
}) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!started || end === 0) {
      setValue(end);
      return;
    }

    const duration = 1400;
    const startTime = performance.now();

    const tick = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(eased * end));
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }, [end, started]);

  return <>{format(value)}</>;
}

export function MetricsStrip() {
  const [started, setStarted] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="st-metrics-section"
      ref={ref}
      aria-label="Key metrics"
    >
      <div className="st-container">
        <div className="st-metrics-grid">
          {METRICS.map((m, i) => (
            <div key={i} className="st-metric-card">
              <p
                className={m.accent ? "st-metric-value accent" : "st-metric-value"}
              >
                <CountUp end={m.end} format={m.format} started={started} />
              </p>
              <p className="st-metric-label">
                {landingContent.metrics[m.key]}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
